import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Folder, Settings } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useSwUpdateStore } from '@store/sw-update-store';

export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const updateAvailable = useSwUpdateStore((s) => s.updateAvailable);

  const getCurrentValue = () => {
    if (location.pathname === '/') return 0;
    if (location.pathname.includes('/session')) return 1;
    if (location.pathname.includes('/settings')) return 2;
    return 0;
  };

  const handleSessionsClick = () => {
    // Always navigate to /sessions — the page handles redirect if no active sessions
    navigate('/sessions');
  };

  return (
    <Paper
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1100 }}
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={(_event, newValue) => {
          if (newValue === 0) navigate('/');
          if (newValue === 1) handleSessionsClick();
          if (newValue === 2) navigate('/settings');
        }}
        showLabels
      >
        <BottomNavigationAction label={t('nav.home')} icon={<Home />} />
        <BottomNavigationAction label={t('nav.sessions')} icon={<Folder />} />
        <BottomNavigationAction
          label={t('nav.settings')}
          icon={
            <Badge variant="dot" color="error" invisible={!updateAvailable}>
              <Settings />
            </Badge>
          }
        />
      </BottomNavigation>
    </Paper>
  );
}
